import { Textarea } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useAutomaticPaymentRemindersModalForm } from '@features/invoicingSettings/modules/paymentsAndReminders'

const TEXT_AREA_ROWS_COUNT = 6
const TEXT_AREA_MAX_HEIGHT = 160

export const AutomaticPaymentRemindersEmailBody = (): ReactElement => {
  const { t } = useTranslation()
  const { automaticPaymentRemindersModalForm } = useAutomaticPaymentRemindersModalForm()
  const { FormItem } = automaticPaymentRemindersModalForm

  return (
    <FormItem
      label={t('settings.organization.external_invoice.automatic_payment_reminders.modal.form.email_message.label')}
      name="emailBody"
      render={({ field }) => {
        return <Textarea {...field} maxHeight={TEXT_AREA_MAX_HEIGHT} resizable rows={TEXT_AREA_ROWS_COUNT} />
      }}
    />
  )
}
